var React = require('react');

function ProfileActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.9999 8C16.9999 5.23858 14.7613 3 11.9999 3C9.23849 3 6.99991 5.23858 6.99991 8C6.99991 10.7614 9.23849 13 11.9999 13C14.7613 13 16.9999 10.7614 16.9999 8ZM11.9999 15C15.5264 15 18.4438 17.6077 18.929 21H5.0708C5.55603 17.6077 8.47344 15 11.9999 15Z","fill":"var(--palette-primary)"}));
}

ProfileActive.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ProfileActive;

ProfileActive.default = ProfileActive;
